Vendd.Scripts.load(function () {
  const sliderContainers = document.querySelectorAll(".x-swiper-container");
  if (sliderContainers.length === 0) return;

  sliderContainers.forEach(function (sliderContainer) {
    manipulateSlider(sliderContainer);

    const thumbsElement = sliderContainer.querySelector(".x-thumbs");
    let thumbs = null;

    if (thumbsElement) {
      const thumbsSwiperElement = thumbsElement.querySelector(".x-thumbs-swiper");

      if (thumbsSwiperElement) {
        thumbs = new Swiper(thumbsSwiperElement, {
          loop: false,
          slidesPerView: "auto",
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        });
      }
    }

    const sliderElement = sliderContainer.querySelector(".x-swiper-slider");

    const sliderId = sliderElement.getAttribute("data-slider-id");
    const loop = sliderElement.getAttribute("data-slider-loop") === "true";
    const numOfSlides = parseInt(sliderElement.getAttribute("data-slider-slides"), 10);
    const centeredSlides = sliderElement.getAttribute("data-centered-slides") === "true";
    const slidesPerGroup = parseInt(sliderElement.getAttribute("data-slider-slides-group"), 10);
    const speed = parseInt(sliderElement.getAttribute("data-slider-speed"), 10);
    const autoplay = sliderElement.getAttribute("data-slider-autoplay") === "true";
    const autoplayDelay =
      parseInt(sliderElement.getAttribute("data-slider-autoplay-delay"), 10) || 5000;
    const defaultSpace = parseInt(sliderElement.getAttribute("data-slider-space"), 10) || 0;
    const initialSlideIndex =
      parseInt(sliderElement.getAttribute("data-slider-initial-slide"), 10) || 0;
    const navigation = sliderElement.getAttribute("data-navigation") === "true";
    const pagination = sliderElement.getAttribute("data-pagination") === "true";
    const paginationType = sliderElement.getAttribute("data-pagination-type");
    const sliderEffect = sliderElement.getAttribute("data-slider-effect") || "slide";

    var options = {
      loop: loop,
      slidesPerView: numOfSlides,
      centeredSlides: centeredSlides || false,
      slidesPerGroup: slidesPerGroup,
      speed: speed,
      spaceBetween: defaultSpace,
      initialSlide: initialSlideIndex,
      effect: sliderEffect,
    };

    if (thumbs) {
      options.thumbs = {
        swiper: thumbs,
      };
    }

    if (navigation) {
      options.navigation = {
        nextEl: ".thumb-next.slider-" + sliderId,
        prevEl: ".thumb-prev.slider-" + sliderId,
      };
    }

    if (pagination) {
      const base = { el: ".swiper-pagination" };
      if (paginationType === "fraction") options.pagination = { ...base, type: "fraction" };
      else if (paginationType === "progressbar")
        options.pagination = { ...base, type: "progressbar" };
      else options.pagination = { ...base, clickable: true };
    }

    if (autoplay) {
      options.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }

    if (sliderElement.swiper) return;
    sliderElement.swiper = new Swiper(sliderElement, options);

    if (thumbs) {
      thumbs.on("click", function (thumbsSwiper) {
        let targetIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;

        if (clickedSlide) {
          const slideIndexAttr = clickedSlide.getAttribute("data-swiper-slide-index");
          const attrIndex = parseInt(slideIndexAttr, 10);

          if (!Number.isNaN(attrIndex)) {
            targetIndex = attrIndex;
          } else {
            const directIndex = Array.prototype.indexOf.call(thumbsSwiper.slides, clickedSlide);
            if (directIndex >= 0) {
              targetIndex = directIndex;
            }
          }
        }

        if (typeof targetIndex !== "number" || targetIndex < 0) return;

        if (loop && typeof sliderElement.swiper.slideToLoop === "function") {
          sliderElement.swiper.slideToLoop(targetIndex);
        } else {
          sliderElement.swiper.slideTo(targetIndex);
        }
      });
    }

    const autoplayControls = sliderContainer.querySelectorAll(".thumb-autoplay");
    const mainSwiper = sliderElement.swiper;

    if (autoplayControls.length > 0 && autoplay && mainSwiper.autoplay) {
      const autoplayLabelPlay = "Play slideshow";
      const autoplayLabelPause = "Pause slideshow";
      let currentCycleDuration = getSlideDelay();
      let rafId = null;
      let startedAt = 0;
      let progress = 0;
      let isResuming = false;
      // pausing only holds the current slide: navigating to another slide resumes the autoplay
      let userPaused = false;
      let pendingResume = false;

      // per-slide delay (data-swiper-autoplay, e.g. set from a video duration) or the slider default
      function getSlideDelay() {
        const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
        const slideDelay = activeSlide
          ? parseInt(activeSlide.getAttribute("data-swiper-autoplay"), 10)
          : NaN;
        return Math.max(slideDelay > 0 ? slideDelay : autoplayDelay, 1);
      }

      function setProgress(value) {
        const safe = Math.max(0, Math.min(1, value));
        progress = safe;
        autoplayControls.forEach(function (control) {
          control.style.setProperty("--progress", safe);
        });
      }

      function setControlState(isPaused) {
        const label = isPaused ? autoplayLabelPlay : autoplayLabelPause;

        autoplayControls.forEach(function (control) {
          control.classList.toggle("is-paused", isPaused);
          control.setAttribute("aria-label", label);
          control.setAttribute("title", label);
        });
      }

      function stopProgressTicker() {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      function startProgressTicker(resetCycle, elapsedOffset) {
        stopProgressTicker();
        startedAt = performance.now() - (elapsedOffset || 0);

        if (resetCycle) {
          setProgress(0);
        }

        const tick = function () {
          const elapsed = performance.now() - startedAt;
          setProgress(Math.min(elapsed / currentCycleDuration, 1));
          rafId = requestAnimationFrame(tick);
        };

        rafId = requestAnimationFrame(tick);
      }

      mainSwiper.on("slideChangeTransitionStart", function () {
        if (mainSwiper.autoplay.running) {
          currentCycleDuration = getSlideDelay() + speed;
          setProgress(0);
          startProgressTicker(false);
        } else if (userPaused) {
          // autoplay restarts once the transition ends, like a regular autoplay cycle
          userPaused = false;
          pendingResume = true;
          setControlState(false);
          currentCycleDuration = getSlideDelay() + speed;
          setProgress(0);
          startProgressTicker(false);
        } else {
          currentCycleDuration = getSlideDelay();
          setProgress(0);
        }
      });

      // transitionEnd, not slideChangeTransitionEnd: a thumb click slides twice (thumbs module + click handler) and skips the latter
      mainSwiper.on("transitionEnd", function () {
        if (!pendingResume) return;
        pendingResume = false;

        isResuming = true;
        mainSwiper.autoplay.start();
        isResuming = false;
      });

      mainSwiper.on("autoplayStart", function () {
        if (isResuming) return;
        currentCycleDuration = getSlideDelay();
        startProgressTicker(true);
      });

      // e.g. held by vimeoPlayer.js until the first slide's video starts playing
      mainSwiper.on("autoplayStop", function () {
        stopProgressTicker();
      });

      autoplayControls.forEach(function (control) {
        control.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (mainSwiper.autoplay.running || pendingResume) {
            userPaused = true;
            pendingResume = false;
            mainSwiper.autoplay.stop();
            stopProgressTicker();
            setControlState(true);
          } else {
            userPaused = false;
            resumeAutoplay();
            setControlState(false);
          }
        });
      });

      // continue the paused cycle: the ring keeps its progress and the autoplay timer only gets the time left
      function resumeAutoplay() {
        const elapsed = progress * currentCycleDuration;
        const remaining = Math.max(Math.round(currentCycleDuration - elapsed), 1);
        const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
        const slideDelay = activeSlide && activeSlide.getAttribute("data-swiper-autoplay");

        if (activeSlide) activeSlide.setAttribute("data-swiper-autoplay", remaining);

        isResuming = true;
        mainSwiper.autoplay.start();
        isResuming = false;

        setTimeout(function () {
          if (!activeSlide) return;
          if (slideDelay) activeSlide.setAttribute("data-swiper-autoplay", slideDelay);
          else activeSlide.removeAttribute("data-swiper-autoplay");
        }, 0);

        startProgressTicker(false, elapsed);
      }

      setControlState(false);
      currentCycleDuration = getSlideDelay();
      startProgressTicker(true);
    }
  });

  function manipulateSlider(sliderContainer) {

    if (sliderContainer.id === "homepage-promo-banner-slides") {
      const mainSlider = sliderContainer.querySelector(".x-swiper-slider .swiper-wrapper");
      changeImporterDealerPositions(mainSlider);

      const thumbsSlider = sliderContainer.querySelector(".x-thumbs-swiper .swiper-wrapper");
      changeImporterDealerPositions(thumbsSlider);
    }

  }

  function changeImporterDealerPositions(swiperWrapperElement) {
    const slides = swiperWrapperElement.querySelectorAll(".swiper-slide");

    for (const slide of slides) {
      if (slide.dataset.slideIndex === "0" || slide.dataset.slideIndex === "2") {
        slide.dataset.source = "importer";
      } else {
        slide.dataset.source = "dealer";
      }
    }

    const importer = Array.from(slides).filter(function (el) {
      return el.dataset.source === "importer";
    });
    const dealer = Array.from(slides).filter(function (el) {
      return el.dataset.source === "dealer";
    });

    const ordered = buildOrder(importer, dealer, getSwapVariant());
    ordered.forEach(function (el) {
      swiperWrapperElement.appendChild(el);
    });

    function buildOrder(importer, dealer, swapped) {
      var slots = [importer[0], dealer[0], importer[1], dealer[1]].filter(Boolean);
      if (!swapped || slots.length <= 1) return slots;
      var t = slots[0];
      slots[0] = slots[1];
      slots[1] = t; // swap pos 1 & 2
      if (slots.length === 4) {
        t = slots[2];
        slots[2] = slots[3];
        slots[3] = t;
      } // 3 & 4 only when full
      return slots;
    }

    function getSwapVariant() {
        // GB always gets the swapped order, regardless of the cookie
        if (skodaVariables.countryCode == "gb") return true; 

        // Irl always get the default order, regardless of the cookie
        if (skodaVariables.countryCode == "ie") return false;

        var v = getCookie("promoSwap");

        if (v === null) {
            v = Math.random() < 0.5 ? "1" : "0";
            // no Max-Age / Expires => session cookie, dropped when the browser closes
            document.cookie = "promoSwap=" + v + "; path=/; SameSite=Lax";
        }
        return v === "1";
    }

    function getCookie(name) {
      var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
      return match ? match[1] : null;
    }
  }
});
